import React from 'react'
import FormBoxName from './FormBoxName'
import LabelsArray from '../LabelsArray'
import SelectionMiddle from '../SelectionMiddle'
import FormBoxRemark from './FormBoxRemark'
import { OptionalBoxCheckbox } from './OptionalVariableCheckbox'
import { Form, Select } from 'antd'
import { useTranslation } from 'react-i18next'
import { useStore } from '../../../store/store'

const FormCheckboxInfos = ({ box, onBlur, form, updateBoxFn }) => {
  const { t } = useTranslation();
  const configuration = useStore(({ configuration }) => configuration)
  const isDisabled = box.from_linked_section

  return (
    <>
      <FormBoxName box={box} onBlur={onBlur} form={form} />
      <SelectionMiddle
        box={box}
        onBlur={onBlur}
        form={form}
        arrayKey="checkboxs"
        selectionKey="checked"
      />
      <Form.Item
        label={t('checkbox-style')}
        name="checkboxStyleId"
        initialValue={box?.checkboxStyleId ?? configuration.checkboxStyles[0].id}
      >
        <Select
          onSelect={onBlur}
          options={configuration.checkboxStyles.map(style => ({ value: style.id, label: style.name }))}
          disabled={isDisabled}
        />
      </Form.Item>
      <FormBoxRemark box={box} onBlur={onBlur} form={form} />
      <OptionalBoxCheckbox box={box} updateBoxFn={updateBoxFn} />

      <LabelsArray
        box={box}
        onBlur={onBlur}
        form={form}
        arrayKey="checkboxs"
        selectionKey="checked"
        updateBoxFn={updateBoxFn}
      />
    </>
  )
}

export default FormCheckboxInfos
